module.exports = __webpack_public_path__ + "static/media/STFU3.26f10eb5.png";